import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'card-coaching-topic',
	templateUrl: './card-coaching-topic.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class CardCoachingTopicComponent implements OnInit {
	private session: Session = inject(Session);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() coachingTopic: any | undefined;
	@Input() selectionHandler: (coachingTopic: any) => void;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isNarrow = true;
		
		this.vm.onSelected = this.onSelected;
		this.vm.isSelected = this.isSelected;
		
		this.handleComponentInit();
	}
	
	handleComponentInit() {
		var origin: any = this.session.getSession().user.origin;
		
		this.vm.imageUrl = this.vm.coachingTopic.iconUrl
			? this.vm.coachingTopic.iconUrl
			: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-coaching-topics.png';
		this.vm.title = (this.vm.coachingTopic.translation && this.vm.coachingTopic.translation.title)
			? this.vm.coachingTopic.translation.title
			: this.vm.coachingTopic.title;
		this.vm.text = (this.vm.coachingTopic.translation && this.vm.coachingTopic.translation.description)
			? this.vm.coachingTopic.translation.description
			: this.vm.coachingTopic.description;
		
		this.vm.isInitialized = true;
	}
	
	onSelected() {
		this.vm.selectionHandler(this.vm.coachingTopic);
	}
	
	isSelected() {
		var params: any = this.angularRoutingHelperService.getQueryParams();
		if (params['coachingTopics']) {
			var selectedTopics: any = "" + params['coachingTopics'];
			return selectedTopics.includes(this.vm.coachingTopic.id);
		} else {
			return false;
		}
	}
	
}